(() => {
  if (customElements.get('drapeur-delivery')) return;
  const dayMs = 86400000;
  const holidaysByYear = new Map();
  const key = date => date.toISOString().slice(0, 10);
  const nextDay = date => new Date(date.getTime() + dayMs);
  function holidays(year) {
    if (holidaysByYear.has(year)) return holidaysByYear.get(year);
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = (h + l - 7 * m + 114) % 31 + 1;
    const easter = new Date(Date.UTC(year, month - 1, day));
    const days = new Set(['01-01', '05-01', '05-08', '07-14', '08-15', '11-01', '11-11', '12-25'].map(value => `${year}-${value}`));
    [1, 39, 50].forEach(offset => days.add(key(new Date(easter.getTime() + offset * dayMs))));
    holidaysByYear.set(year, days);
    return days;
  }
  const working = date => date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !holidays(date.getUTCFullYear()).has(key(date));
  function nextWorking(date) {
    let result = nextDay(date);
    while (!working(result)) result = nextDay(result);
    return result;
  }
  class DrapeurDelivery extends HTMLElement {
    static estimate(now) {
      const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
      }).formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
      const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
      const before = working(today) && Number(parts.hour) < 14;
      const dispatch = before ? today : nextWorking(today);
      const minutes = Math.ceil((14 * 3600 - Number(parts.hour) * 3600 - Number(parts.minute) * 60 - Number(parts.second)) / 60);
      return { minutes, before, dispatch, delivery: nextWorking(dispatch), tomorrow: nextDay(today) };
    }
    connectedCallback() {
      this.ready = this.dataset.ready === 'true';
      this.variants = JSON.parse(this.querySelector('[data-delivery-variants]').textContent);
      this.texts = Object.fromEntries(Array.from(this.querySelectorAll('[data-delivery-text]'), el => [el.dataset.deliveryText, el.content.textContent]));
      this.message = this.querySelector('[data-delivery-message]');
      this.scope = this.closest('[data-section-type="product"]');
      this.onVariant = event => {
        this.ready = !!(event.detail.variant && this.variants[event.detail.variant.id]);
        this.refresh();
      };
      this.onVisible = () => { if (!document.hidden) this.refresh(); };
      this.scope?.addEventListener('variantChange', this.onVariant, true);
      document.addEventListener('visibilitychange', this.onVisible);
      this.refresh();
      this.timer = setInterval(() => this.refresh(), 30000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.scope?.removeEventListener('variantChange', this.onVariant, true);
      document.removeEventListener('visibilitychange', this.onVisible);
    }
    refresh() {
      this.hidden = !this.ready;
      if (this.hidden) return;
      const estimate = DrapeurDelivery.estimate(new Date());
      const france = this.dataset.country === 'FR';
      const date = france ? estimate.delivery : estimate.dispatch;
      let template;
      if (france) {
        template = estimate.before ? (key(date) === key(estimate.tomorrow) ? 'tomorrow' : 'before') : 'delivery';
      } else {
        template = estimate.before ? 'today' : 'dispatch';
      }
      const label = new Intl.DateTimeFormat(this.dataset.locale || 'fr', { day: 'numeric', month: 'long', timeZone: 'UTC' }).format(date);
      const hours = Math.floor(estimate.minutes / 60);
      const minutes = estimate.minutes % 60;
      const time = hours ? `${hours} h ${String(minutes).padStart(2, '0')}` : `${minutes} min`;
      this.message.textContent = this.texts[template].replace('__DATE__', label).replace('__TIME__', time);
    }
  }
  customElements.define('drapeur-delivery', DrapeurDelivery);
})();
